export function initSmallCardCarousel() {
  const carousel = document.querySelector('.small-card-carousel');
  if (!carousel) return;

  // On mobile the cards are shown as a static 2x2 grid (see _responsive.scss),
  // so skip the cloning + marquee animation entirely.
  if (window.matchMedia('(max-width: 680px)').matches) return;

  const track = carousel.querySelector('.small-card-track');
  const originals = Array.from(track.children);
  const total = originals.length;
  if (!total) return;

  // Duplicate the full set so the strip can scroll continuously and seamlessly
  originals.forEach(card => {
    const clone = card.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);
  });

  // We drive the transform every frame, so no CSS transition.
  track.style.transition = 'none';

  const SPEED = 40; // px per second

  // Width of one full set of original cards (card + gap), i.e. the wrap distance.
  function setWidth() {
    return (originals[0].getBoundingClientRect().width + 20) * total;
  }

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let width = setWidth();
  let offset = 0;
  let paused = reduceMotion;
  let last = performance.now();

  function frame(now) {
    const dt = (now - last) / 1000;
    last = now;
    if (!paused) {
      offset += SPEED * dt;
      if (offset >= width) offset -= width;
      track.style.transform = `translateX(-${offset}px)`;
    }
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);

  // Pause on hover for readability
  carousel.addEventListener('mouseenter', () => { if (!reduceMotion) paused = true; });
  carousel.addEventListener('mouseleave', () => { if (!reduceMotion) paused = false; });

  window.addEventListener('resize', () => {
    const next = setWidth();
    offset = width ? (offset / width) * next : 0; // keep proportional position
    width = next;
  });
}
